import { render, staticRenderFns } from "./see.vue?vue&type=template&id=84d4e272&scoped=true&"
import script from "./see.vue?vue&type=script&lang=js&"
export * from "./see.vue?vue&type=script&lang=js&"
import style0 from "./see.vue?vue&type=style&index=0&id=84d4e272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d4e272",
  null
  
)

export default component.exports